export default "__VITE_ASSET__JDkeUZk2__"